import { FC } from 'react';
import { useSelector } from 'react-redux';
import { clientNameSelector } from '../../../../redux/auth/selectors';
import PrincipleAdverseImpactOverviewPanel from './PrincipleAdverseImpactOverviewPanel.component';
import PrincipleAdverseImpactReportTable from './PrincipleAdverseImpactReportTable.component';
import PrincipleAdverseImpactTable from './PrincipleAdverseImpactTable.component';
import NonPremiumSubscriptionDisplayMessage, {
  doesClientHavePremiumPackage,
} from '../NonPremiumSubscriptionDisplay/NonPremiumSubscriptionDisplayMessage.component';
import { Grid } from '@mui/material';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import {
  EsgPages,
  useEsgCodeDescriptions,
  useEsgFundData,
  type EsgCodeDescriptions,
  type EsgPortfolioSummaryPageModel,
} from '../../../../api/rs-hg/esg';

type PaiQueryData = {
  pageModel: EsgPortfolioSummaryPageModel;
  rulesData: EsgCodeDescriptions;
};

const PrincipleAdverseImpact: FC<FundInfoComponentProps> = ({
  fundName,
  fundId,
  positionDate,
}) => {
  const clientName = useSelector(clientNameSelector);
  const portfolioSummaryQuery = useEsgFundData(
    fundId,
    positionDate,
    EsgPages.PRINCIPLE_ADVERSE_IMPACT,
  );
  const codeDescriptionsQuery = useEsgCodeDescriptions();

  return (
    <QueryBoundary<PaiQueryData>
      isLoading={
        portfolioSummaryQuery.isLoading || codeDescriptionsQuery.isLoading
      }
      isFetching={
        portfolioSummaryQuery.isFetching || codeDescriptionsQuery.isFetching
      }
      isError={portfolioSummaryQuery.isError || codeDescriptionsQuery.isError}
      error={portfolioSummaryQuery.error ?? codeDescriptionsQuery.error}
      data={
        portfolioSummaryQuery.data?.data &&
        Object.keys(portfolioSummaryQuery.data.data).length > 0 &&
        !('no data' in portfolioSummaryQuery.data.data) &&
        codeDescriptionsQuery.data &&
        Object.keys(codeDescriptionsQuery.data).length > 0
          ? {
              pageModel: portfolioSummaryQuery.data,
              rulesData: codeDescriptionsQuery.data,
            }
          : null
      }
      loadingMessages={['Loading ESG Data...', '...']}
      errorMessage="No ESG Data Found"
      noDataMessage="No ESG Data Found"
    >
      {({ pageModel, rulesData }) =>
        doesClientHavePremiumPackage(pageModel.data) ? (
          <Grid container spacing={2} style={{ padding: 8 }}>
            <PrincipleAdverseImpactOverviewPanel
              data={pageModel.data}
              fundName={fundName}
            />
            <PrincipleAdverseImpactTable
              esgData={pageModel.data}
              rulesData={rulesData}
            />
            {clientName === 'mersenne' && <PrincipleAdverseImpactReportTable />}
          </Grid>
        ) : (
          <NonPremiumSubscriptionDisplayMessage />
        )
      }
    </QueryBoundary>
  );
};

export default PrincipleAdverseImpact;
